import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { StatusBadge } from './StatusBadge';

const VISIBLE_COUNT = 5;

export const ProgramLocationsCard = ({ locations }) => {
    const [expanded, setExpanded] = useState(false);
    const visibleLocations = expanded ? locations : locations.slice(0, VISIBLE_COUNT);
    const remainingCount = locations.length - VISIBLE_COUNT;

    return (
        <div className="card p-3 mb-3 h-100">
            <h5 className="text-strong mb-3">Program Locations</h5>
            <label className="d-block text-muted">Approved Locations</label>
            <ul className="p-0 mb-2 no-bullets">
                {visibleLocations.map(location => (
                    <li key={location.id} className="d-flex align-items-center justify-content-between py-1">
                        <span>{location.name}</span>
                        <StatusBadge status={location.status} />
                    </li>
                ))}
            </ul>
            {remainingCount > 0 && (
                <Button color="link" className="p-0" onClick={() => setExpanded(!expanded)}>
                    {expanded ? 'Show fewer locations' : `Show ${remainingCount} more locations`}
                </Button>
            )}
        </div>
    );
};
